import React, { Fragment, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from "react-redux";
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import {
  getDate,
  getItemFromStorage,
  setItemToStorage,
  userPicUrl,
} from "../../utils/Helper";
import { BookingDetailAction } from "../../Redux/Action/BokkingAction";
import {
  decodeID,
  getLastURL,
  getStatus,
  convertToBrowserTime,
} from "../../utils/Helper";
import moment from "moment";

function BookingDetails() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const log_in = useSelector((state: any) => state.BookingDetailState);
  const bookingdata = useSelector(
    (state: any) => state.BookingDetailState?.data?.data,
  );
  const location = useLocation();
  const editId = getLastURL(location);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState("0");
  const [totalService, setTotalservice] = useState([]);

  useEffect(() => {
    setLoading(true);
    var params = {
      detail_id: decodeID(editId),
    };
    dispatch(BookingDetailAction(params));
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);

  useEffect(() => {
    const view = {
      id: bookingdata?.service_details.id,
      service_details: {
        name: bookingdata?.service_details.name,
        price: bookingdata?.service_details.price,
      },
      slot_et: bookingdata?.slot_et,
      slot_st: bookingdata?.slot_st,
    };
    const updatedServices: any = [
      ...(bookingdata?.parent_id_details || []),
      view,
    ];

    setTotalservice(updatedServices);
    setTimeout(() => {
      const totalAmount = bookingdata?.parent_id_details?.reduce(
        (acc: any, res: any) => {
          return acc + res.amount;
        },
        0,
      );
      setTotal(totalAmount + bookingdata?.amount);
    }, 1000);
  }, [bookingdata?.parent_id_details]);

  return (
    <Fragment>
      {loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Booking Management"
        breadcrumbs={{
          secLast: { link: "/booking-list", name: "Booking Management" },
        }}
        buttons={[
          {
            url: "/class-add",
            className: "btn btn-primary",
            text: "+ Add Sponsors",
            show: false,
          }, // This button will be shown
        ]}
      >
        <div className="card">
          <div className="card-body">
            <div className="row gy-4">
              <div className="col-12">
                <h5>Booking Details</h5>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Booking ID :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>{bookingdata?.u_id ? bookingdata?.u_id : "--"}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Customer Name :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>
                      {bookingdata?.user_details?.name
                        ? bookingdata?.user_details?.name
                        : "--"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Salon Name :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>
                      {bookingdata?.salon_details?.salon_name
                        ? bookingdata?.salon_details?.salon_name
                        : "--"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Booking Status :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>{getStatus(bookingdata?.status)}</span>
                  </div>
                </div>
              </div>
              {bookingdata?.status != "1" ? (
                <div className="col-xl-6">
                  <div className="row">
                    <div className="col-md-4 col-lg-2 col-xl-3">
                      <label htmlFor="username" className="form-label">
                        Services :
                      </label>
                    </div>
                    <div className="col-md-8 col-lg-10 col-xl-9">
                      <div className="col-md-9">
                        <span className="service-tag">
                          {bookingdata?.service_details?.name
                            ? bookingdata?.service_details?.name
                            : "--"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Booking date :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>
                      {bookingdata?.booking_date
                        ? getDate(bookingdata?.booking_date)
                        : "--"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      {bookingdata?.status == "0" ? (
                        <p>Upcoming date :</p>
                      ) : bookingdata?.status == "1" ? (
                        <p>Complete date :</p>
                      ) : bookingdata?.status == "2" ? (
                        <p>Cancelled date :</p>
                      ) : (
                        <p>No Shown-up date :</p>
                      )}
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>
                      {bookingdata?.updated_at
                        ? getDate(bookingdata?.updated_at)
                        : "--"}
                    </span>
                  </div>
                </div>
              </div>
              {bookingdata?.status == "2" ? (
                <div className="col-lg-6">
                  <div className="row">
                    <div className="col-md-4 col-lg-5 col-xl-3">
                      <label htmlFor="username" className="form-label">
                        {bookingdata?.status == "2" ? "Booking cancel by" : ""}
                      </label>
                    </div>
                    <div className="col-md-8 col-lg-7 col-xl-9">
                      <span>
                        {bookingdata?.changed_by == "2" ? "Salon" : "User"}
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Booking Type :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>
                      {bookingdata?.booking_status == "1" ? (
                        <p>Online</p>
                      ) : (
                        <p>Offline</p>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {bookingdata?.status != "1" ? (
                <>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-md-4 col-lg-5 col-xl-3">
                        <label htmlFor="username" className="form-label">
                          Total Amount :
                        </label>
                      </div>
                      <div className="col-md-8 col-lg-7 col-xl-9">
                        <span>
                          {bookingdata?.amount ? bookingdata?.amount : "--"}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>

        {bookingdata?.status == "1" ? (
          <div className="card">
            <div className="card-body">
              <div className="row gy-4">
                <div className="col-12">
                  <h5>Payment Summary</h5>
                </div>
              </div>
              <div className="col-xl-6">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Service Name</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Slot Start Time</th>
                      <th scope="col">Slot End Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {totalService &&
                      totalService.map((res: any, i: any) => (
                        <tr key={i}>
                          <td>{res?.service_details?.name}</td>
                          <td>{res?.service_details?.price}</td>
                          <td>
                            {res?.slot_st
                              ? moment
                                  .utc(res?.slot_st)
                                  .local()
                                  .format("h:mm A, MMM DD, Y")
                              : "Additional Service"}
                          </td>
                          <td>
                            {res?.slot_et
                              ? moment
                                  .utc(res?.slot_et)
                                  .local()
                                  .format("h:mm A, MMM DD, Y")
                              : "Additional Service"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Total Amount :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>{total}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
         {bookingdata?.rating_details ? (
          <div className="card">
            <div className="card-body">
              <div className="row gy-4">
                <div className="col-12">
                  <h5>Rating Review</h5>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Rate :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>{bookingdata?.rating_details?.rate}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-lg-5 col-xl-3">
                    <label htmlFor="username" className="form-label">
                      Review :
                    </label>
                  </div>
                  <div className="col-md-8 col-lg-7 col-xl-9">
                    <span>{bookingdata?.rating_details?.comments}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="mt-3 ">
          <Link
            to={"/booking-list"}
            type="submit"
            className="btn btn-primary waves-effect waves-light"
          >
            BACK
          </Link>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default BookingDetails;
